
import * as SRD from '@projectstorm/react-diagrams';
import { DeleteItemsAction } from '@projectstorm/react-canvas-core';
import { MetricsNodeFactory } from './MetricsNodeFactory';
import { MetricsPortFactory } from './MetricsPortFactory';
export class MetricsApplication {
    protected activeModel: SRD.DiagramModel;
    protected diagramEngine: SRD.DiagramEngine;
    _onChange: any;
    constructor() {
        this.diagramEngine = SRD.default({
            registerDefaultDeleteItemsAction: false
        });
        this.activeModel = new SRD.DiagramModel();
        this.diagramEngine.getPortFactories()
            .registerFactory(new MetricsPortFactory());
        this.diagramEngine.getNodeFactories().registerFactory(new MetricsNodeFactory());
        // register an DeleteItemsAction with custom keyCodes (in this case, only Delete key)
        this.diagramEngine.getActionEventBus().registerAction(new DeleteItemsAction({ keyCodes: [46] }));

        // register our label factory
        this.newModel();
    }
    public onChange(func: any) {
        this._onChange = func;
    }
    public deserialize(str: string) {
        this.newModel(str);
        if (this._onChange) {
            this._onChange();
        }
    }
    public newModel(data?: string) {
        this.activeModel = new SRD.DiagramModel();

        this.activeModel.registerListener({
            nodeSelectionChanged: (event: any) => {
                if (this._onChange) {
                    this._onChange();
                }
            },
            nodeUpdate: () => {
                if (this._onChange) {
                    this._onChange();
                }
            }
        });
        this.diagramEngine.setModel(this.activeModel);
        if (data) {
            this.activeModel.deserializeModel(JSON.parse(data), this.diagramEngine);
        }

    }
    public getActiveDiagram(): SRD.DiagramModel {
        return this.activeModel;
    }

    public getDiagramEngine(): SRD.DiagramEngine {
        return this.diagramEngine;
    }
}
